<template>
  <button
    type="button"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <AddFieldIcon
      v-if="icon === 'add'"
      class="h-5 w-5 fill-current"
      :class="{
        'cursor-pointer': !disabled,
        'opacity-50': disabled
      }"
    />
    <font-awesome-icon
      v-else-if="icon === 'remove'"
      :class="{
        'text-red-500 hover:text-red-700 cursor pointer': !disabled,
        'text-base-content-100': disabled
      }"
      icon="trash"
    />
  </button>
</template>

<script>
import AddFieldIcon from "@/assets/icons/check-admin/add-field.svg";

export default {
  name: "SectionHeaderControl",

  components: {
    AddFieldIcon
  },

  props: {
    icon: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
